Object.defineProperty(exports, "__esModule", { value: true });
exports.theBodyShopDarkColorTokens = exports.theBodyShopLightColorTokens = void 0;
var the_body_shop_light_1 = require("./the-body-shop-light");
Object.defineProperty(exports, "theBodyShopLightColorTokens", { enumerable: true, get: function () { return the_body_shop_light_1.theBodyShopLightColorTokens; } });
var the_body_shop_dark_1 = require("./the-body-shop-dark");
Object.defineProperty(exports, "theBodyShopDarkColorTokens", { enumerable: true, get: function () { return the_body_shop_dark_1.theBodyShopDarkColorTokens; } });
//# sourceMappingURL=index.js.map